export default {
  today: 'Hoy',
  now: 'Ahora',
  backToToday: 'Volver a hoy',
  ok: 'Aceptar',
  clear: 'Limpiar',
  month: 'Mes',
  year: 'AÃ±o',
  timeSelect: 'Seleccionar hora',
  dateSelect: 'Seleccionar fecha',
  monthSelect: 'Elegir un mes',
  yearSelect: 'Elegir un aÃ±o',
  decadeSelect: 'Elegir una dÃ©cada',
  yearFormat: 'YYYY',
  dateFormat: 'D/M/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Mes anterior (PageUp)',
  nextMonth: 'Mes siguiente (PageDown)',
  previousYear: 'AÃ±o anterior (Control + left)',
  nextYear: 'AÃ±o siguiente (Control + right)',
  previousDecade: 'DÃ©cada anterior',
  nextDecade: 'DÃ©cada siguiente',
  previousCentury: 'Siglo anterior',
  nextCentury: 'Siglo siguiente',
};
